import {
    AfterViewInit,
    Component,
    Input,
    OnInit,
    ViewChild
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatInput } from '@angular/material/input';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Authorization, UserCommunication, UserRole } from '@data/models/authorization.model';
import { AuthorizationService } from '@data/services/authorization.service';
import { Role } from '@data/models/role.model';
import { commSortingDataAccessor } from '@shared/utils/angular-material-tools';
import { AclsDetailsDialogComponent } from '../acls-details-dialog/acls-details-dialog.component';
import { AppService } from '@data/services/app.service';
import { App } from '@data/models/app.model';

const DEFAULT_LIST_SIZE = 10;

@Component({

    selector: 'syn-user-authorizations',
    templateUrl: 'user-authorizations.component.html',
    styleUrls: ['user-authorizations.component.scss']
})
export class UserAuthorizationsComponent implements OnInit, AfterViewInit {

    @Input() globalRoles: Role[] = [];
    @Input() userRoles: UserRole[];
    @Input() userCommunications: UserCommunication[];

    @ViewChild(MatPaginator) paginator: MatPaginator;

    public allApps: App[] = [];

    public dataSource: MatTableDataSource<Authorization>;
    public displayedColumns: String[] = ['$project.name', 'roles', 'mso', 'incident', 'request', 'patch', 'change', 'billing'];
    public showPaginator = true;
    public pageSizeOptions: Number[] = [5, 10, 25, 100];
    public pageSize = DEFAULT_LIST_SIZE;
    public pageIndex = 0;

    constructor(
        private matDialog: MatDialog,
        private authorizationService: AuthorizationService,
        private appService: AppService
    ) { }

    @ViewChild(MatSort) set sort(value: MatSort) {
        if (this.dataSource) {
            this.dataSource.sort = value;
        }
    }


    ngOnInit(): void {
        this.dataSource = new MatTableDataSource<Authorization>(
            this.authorizationService.getUserAuthorizations(this.userRoles, this.userCommunications)
        );

        this.appService.findApps().subscribe((apps) => this.allApps = apps);
    }

    ngAfterViewInit(): void {
        // Assign paginator and sorter to Mat Table
        this.dataSource.sortingDataAccessor = commSortingDataAccessor;
        this.dataSource.paginator = this.paginator;
    }

    getAppByRole(role: string): string{
        return this.globalRoles.find((rle) => rle.id === role).app;
    }

    /**
     * Display acls information dialog
     */
    displayAclsInformation(row: Authorization): void {
        this.matDialog.open(AclsDetailsDialogComponent, {
            data: {
                roles: this.globalRoles,
                row: row
            },
            width: '800px'
        });
    }

    /**
     * Mat Table filter
     */
    applyFilter(term: string, input?: MatInput): void {
        this.dataSource.filter = term.trim().toLowerCase();

        if (input) {
            input.value = term;
        }
    }

    computeRoleLine(role: string): string {
        let appName = '';

        if (this.allApps){
            appName = this.allApps?.find((app) => app.id === this.getAppByRole(role))?.name ?? '';
        }
        return`${appName} : ${role}`;
    }

}
